var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logout-box"},[_c('Spin',{attrs:{"fix":""}},[_c('Icon',{staticClass:"demo-spin-icon-load",attrs:{"type":"ios-loading","size":"18"}}),_c('div',[_vm._v(_vm._s(_vm.$t('key1006542')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }